import keycloak from "../../../keycloak";

export const getUserAccessToken = async () => {
  let token = keycloak.token;
  if (!token) {
    keycloak.login();
    return;
  } else {
    let isTokenExpired = keycloak.isTokenExpired();
    // console.log("is token expired", isTokenExpired);
    if (isTokenExpired) {
      try {
        let flag = await keycloak.updateToken(180);
        if (flag) {
          return keycloak.token;
        } else {
          keycloak.login();
        }
      } catch (e) {
        keycloak.login();
      }
    } else {
      return token;
    }
  }
};
